import { isClientSideRendered as e } from "../../utils/ssr.js";
var t = e() && document.querySelector("html"),
  r = e() && t ? window.getComputedStyle(t, null).getPropertyValue("font-size") : "",
  n = 16,
  o = ("" !== r ? parseFloat(r) : 16) / 16 * 16,
  u = function u() {
    var t = "";
    for (var _n = 0; _n < arguments.length; ++_n) {
      var _u = _n < 0 || arguments.length <= _n ? undefined : arguments[_n];
      "" !== t && (t += " ");
      var l = (r = _u, {
        number: parseFloat(r),
        units: String(r).replace(/^[\d.-]+/, "")
      });
      "rem" !== l.units ? t += l.number / o : t += l.number, 0 !== l.number && (t += "rem");
    }
    var r;
    return t;
  };
export { u as default, n as remBase };